import styled from "@emotion/styled";
import { Icon } from "@iconify/react";
import Modal from "@mui/material/Modal";
import { useState } from "react";
import { toast } from "react-toastify";
import { leaveTypes } from "../lib/constants";
import { useEmployee } from "../services";
import Select from "./Select";

const ModalWrapper = styled(Modal)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const leaveTypeOptions = leaveTypes.map((type) => ({ value: type, label: type }));

const sessionOptions = [
  // Full Day, Session 1 (First Half of the day), Session 2 (Second Half of the day)
  { value: "Full Day", label: "Full Day" },
  { value: "Session 1 (First Half of the day)", label: "Session 1 (First Half of the day)" },
  { value: "Session 2 (Second Half of the day)", label: "Session 2 (Second Half of the day)" },
];

const sessionMap = {
  "Session 1 (First Half of the day)": "First Half",
  "Session 2 (Second Half of the day)": "Second Half",
  "Full Day": "Full Day",
};

function AddLeaveFormModal({ open, onClose, onSubmit = () => {} }: { open: any; onClose: any; onSubmit?: () => void }) {
  const initialFormData = {
    leave_type: "",
    start_date: "",
    start_date_session: "",
    end_date: "",
    end_date_session: "",
    number_of_days: "",
    reason: "",
    is_paid: true,
    attachment: null,
  };
  const [formData, setFormData] = useState(initialFormData);
  const { requestLeave } = useEmployee();

  const handleClose = () => {
    setFormData(initialFormData);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const startDate = new Date(formData.start_date);
    const endDate = new Date(formData.end_date);
    let daysCount = (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24) + 1;

    if (!formData.end_date) daysCount = 1;
    else if (formData.end_date_session !== "Full Day") {
      daysCount -= 0.5;
    }
    if (formData.start_date_session !== "Full Day") {
      daysCount -= 0.5;
    }
    const dataToSubmit = {
      ...formData,
      number_of_days: daysCount,
      start_date_session: sessionMap[formData.start_date_session],
      employee_id: JSON.parse(localStorage.getItem("userData")).employee_id,
      end_date_session: sessionMap[formData.end_date_session],
    };
    const { success, error } = await requestLeave(dataToSubmit);
    if (error) return toast.error(error);
    else {
      console.log(success);
      toast.success(success);
      handleClose();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, attachment: file });
  };

  return (
    <ModalWrapper
      open={open}
      onClose={handleClose}
      aria-labelledby="add-leave-modal"
      aria-describedby="add-leave-modal"
    >
      <div className="modal_container full column">
        <h3 className="section_title">Applying for leave</h3>
        <form id="add_leave_form" className="column small" onSubmit={handleSubmit}>
          <div className="input_wrapper">
            <label htmlFor="leave_type" className="label">
              Leave Type*
            </label>
            <Select
              name="leave_type"
              id="leave_type"
              placeholder="Select Leave Type"
              options={leaveTypeOptions}
              required
              value={formData.leave_type}
              onChange={(value) => setFormData({ ...formData, leave_type: value })}
            />
          </div>
          <div className="input_wrapper">
            <label htmlFor="start_date" className="label">
              Period of Leave*
            </label>
            <div className="row">
              <input
                type="date"
                name="start_date"
                id="start_date"
                className="input full"
                required
                value={formData.start_date}
                onChange={(e) => setFormData({ ...formData, start_date: e.target.value })}
                min={new Date().toISOString().split("T")[0]}
              />
              <Select
                name="start_date_session"
                id="start_date_session"
                placeholder="Select Session"
                options={sessionOptions}
                required
                value={formData.start_date_session}
                onChange={(value) => setFormData({ ...formData, start_date_session: value })}
                full
              />
            </div>
          </div>
          <div className="input_wrapper">
            <label htmlFor="end_date" className="label">
              Period of Leave*
            </label>
            <div className="row">
              <input
                type="date"
                name="end_date"
                id="end_date"
                className="input full"
                value={formData.end_date}
                onChange={(e) => setFormData({ ...formData, end_date: e.target.value })}
                min={formData.start_date}
              />
              <Select
                name="end_date_session"
                id="end_date_session"
                placeholder="Select Session"
                options={sessionOptions}
                required={formData.end_date}
                value={formData.end_date_session}
                onChange={(value) => setFormData({ ...formData, end_date_session: value })}
                full
              />
            </div>
          </div>
          <div className="input_wrapper">
            <label htmlFor="reason" className="label">
              Reason
            </label>
            <textarea
              name="reason"
              id="reason"
              className="textarea"
              required
              value={formData.reason}
              onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
              rows={4}
            ></textarea>
          </div>
          <div className="row start">
            <label className="label gray">
              <input
                type="file"
                name="attachment"
                id="attachment"
                accept="application/pdf"
                onChange={handleFileChange}
                hidden
              />
              <span>
                <Icon icon="ion:attach-outline" className="icon" inline />
                <span className="underline">Attach File</span>
              </span>
            </label>
          </div>
          <div className="row end">
            <button type="button" className="btn ghost_outline_btn" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn cta_btn">
              Save
            </button>
          </div>
        </form>
      </div>
    </ModalWrapper>
  );
}

export default AddLeaveFormModal;
